import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ArrowRight, CheckCircle, Copy, Check, MessageSquare, Smartphone, FileText, Search, Clock, Link as LinkIcon, BarChart3, TrendingUp, User, Video, Star, Zap, Share2 } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FeaturesPage() {
  const [copied, setCopied] = useState(false);
  const phoneNumber = '(774) 472-7423';
  const smsHref = `sms:+1${phoneNumber.replace(/\D/g, '')}?body=Hi%20ScribeTok!%20I%20want%20to%20transcribe%20a%20video.`;
  const handleCopyNumber = () => {
    navigator.clipboard.writeText(phoneNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="min-h-screen w-full bg-background px-4 py-12 md:px-16 lg:px-32 flex flex-col items-center justify-center overflow-x-hidden" data-id="element-109">
      <div className="w-full max-w-4xl mx-auto text-center" data-id="element-110">
        {/* Logo */}
        <div className="flex justify-center mb-6" data-id="element-111">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6tsscMEhsZ3L4JwT2r374e/ScribeTok-logo.png" alt="ScribeTok Logo" className="h-14 w-auto" data-id="element-112" />
        </div>
        {/* Hero Section */}
        <div className="mb-2" data-id="element-113">
          <span className="inline-block bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-114">
            New Creator Features
          </span>
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 animate-slide-down" style={{
        animationDelay: '100ms'
      }} data-id="element-115">
          Unlock Your <span className="text-primary" data-id="element-116">Creator Stats</span>
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8 animate-slide-down" style={{
        animationDelay: '200ms'
      }} data-id="element-117">
          Connect your TikTok account to access powerful analytics, track your
          performance, and get insights on your content—all via text message.
        </p>
        {/* Quick Command Reference */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-12 animate-scale" style={{
        animationDelay: '300ms'
      }} data-id="element-118">
          <Card className="bg-primary/5 border-primary/20" data-id="element-119">
            <CardContent className="p-4 flex flex-col items-center" data-id="element-120">
              <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center mb-3" data-id="element-121">
                <LinkIcon size={20} className="text-primary" data-id="element-122" />
              </div>
              <p className="font-bold" data-id="element-123">/link @handle</p>
              <p className="text-sm text-muted-foreground" data-id="element-124">
                Connect your TikTok
              </p>
            </CardContent>
          </Card>
          <Card className="bg-primary/5 border-primary/20" data-id="element-125">
            <CardContent className="p-4 flex flex-col items-center" data-id="element-126">
              <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center mb-3" data-id="element-127">
                <BarChart3 size={20} className="text-primary" data-id="element-128" />
              </div>
              <p className="font-bold" data-id="element-129">/stats</p>
              <p className="text-sm text-muted-foreground" data-id="element-130">
                View your dashboard
              </p>
            </CardContent>
          </Card>
          <Card className="bg-primary/5 border-primary/20" data-id="element-131">
            <CardContent className="p-4 flex flex-col items-center" data-id="element-132">
              <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center mb-3" data-id="element-133">
                <Video size={20} className="text-primary" data-id="element-134" />
              </div>
              <p className="font-bold" data-id="element-135">/myvideos</p>
              <p className="text-sm text-muted-foreground" data-id="element-136">
                See your top content
              </p>
            </CardContent>
          </Card>
        </div>
        {/* Example SMS Conversation */}
        <div className="mb-16" data-id="element-137">
          <h2 className="text-2xl font-bold mb-6" data-id="element-138">See It In Action</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-139">
            {/* Left Side - Connect Account */}
            <div className="bg-secondary/50 rounded-xl p-4 md:p-6 text-left" data-id="element-140">
              <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-141">
                <LinkIcon size={18} className="text-primary mr-2" data-id="element-142" />
                Connect Your Account
              </h3>
              <div className="space-y-4" data-id="element-143">
                <div className="flex justify-end" data-id="element-144">
                  <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-145">
                    /link @switmer777
                  </div>
                </div>
                <div className="flex justify-start" data-id="element-146">
                  <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-147">
                    <p className="flex items-start gap-2" data-id="element-148">
                      <span className="text-xl flex-shrink-0" data-id="element-149">🔗</span>
                      <span data-id="element-150">
                        Success! Your TikTok account @switmer777 has been linked
                        to ScribeTok.
                      </span>
                    </p>
                    <p className="mt-2 ml-7" data-id="element-151">
                      You can now use /stats to see your creator dashboard and
                      /myvideos to view your top content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Right Side - View Stats */}
            <div className="bg-secondary/50 rounded-xl p-4 md:p-6 text-left" data-id="element-152">
              <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-153">
                <BarChart3 size={18} className="text-primary mr-2" data-id="element-154" />
                View Your Stats
              </h3>
              <div className="space-y-4" data-id="element-155">
                <div className="flex justify-end" data-id="element-156">
                  <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-157">
                    /stats
                  </div>
                </div>
                <div className="flex justify-start" data-id="element-158">
                  <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-159">
                    <p className="flex items-start gap-2" data-id="element-160">
                      <span className="text-xl flex-shrink-0" data-id="element-161">📊</span>
                      <span className="font-medium" data-id="element-162">
                        Your ScribeTok Creator Stats
                      </span>
                    </p>
                    <div className="mt-2 ml-7 space-y-1" data-id="element-163">
                      <p data-id="element-164">🎥 23 videos transcribed</p>
                      <p data-id="element-165">💳 15 credits (0 free remaining)</p>
                      <p data-id="element-166">🎁 4 friends referred (+20 bonus credits)</p>
                      <p data-id="element-167">🔗 Linked: @switmer777</p>
                      <p data-id="element-168">📅 Member since: May 15, 2025</p>
                      <p className="mt-2" data-id="element-169">
                        🏆 Most popular: "How I built my startup" (1.2M views)
                      </p>
                    </div>
                    <p className="text-xs mt-3 text-primary font-medium ml-7" data-id="element-170">
                      Text /myvideos to see your top content!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Benefits Section */}
        <div className="mb-16" data-id="element-171">
          <h2 className="text-2xl font-bold mb-8" data-id="element-172">Creator Benefits</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6" data-id="element-173">
            <div className="flex flex-col items-center text-center p-4" data-id="element-174">
              <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-175">
                <TrendingUp size={24} className="text-primary" data-id="element-176" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-177">Track Performance</h3>
              <p className="text-sm text-muted-foreground" data-id="element-178">
                Monitor views, likes, and engagement across all your TikTok
                content
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-179">
              <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-180">
                <Star size={24} className="text-primary" data-id="element-181" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-182">Identify Top Content</h3>
              <p className="text-sm text-muted-foreground" data-id="element-183">
                See which videos perform best and understand what resonates with
                your audience
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-184">
              <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-185">
                <Zap size={24} className="text-primary" data-id="element-186" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-187">
                Special Creator Perks
              </h3>
              <p className="text-sm text-muted-foreground" data-id="element-188">
                Get extra features when transcribing your own content
              </p>
            </div>
          </div>
        </div>
        {/* My Videos Example */}
        <div className="mb-16" data-id="element-189">
          <h2 className="text-2xl font-bold mb-6" data-id="element-190">Your Top Content</h2>
          <div className="bg-secondary/50 rounded-xl p-4 md:p-6 text-left max-w-xl mx-auto" data-id="element-191">
            <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-192">
              <Video size={18} className="text-primary mr-2" data-id="element-193" />
              Top Videos Command
            </h3>
            <div className="space-y-4" data-id="element-194">
              <div className="flex justify-end" data-id="element-195">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-196">
                  /myvideos
                </div>
              </div>
              <div className="flex justify-start" data-id="element-197">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-198">
                  <p className="flex items-start gap-2" data-id="element-199">
                    <span className="text-xl flex-shrink-0" data-id="element-200">📱</span>
                    <span className="font-medium" data-id="element-201">
                      Your Top TikTok Videos (@switmer777)
                    </span>
                  </p>
                  <div className="mt-2 ml-7 space-y-3" data-id="element-202">
                    <div data-id="element-203">
                      <p className="font-medium" data-id="element-204">
                        1. "How I built my startup in 30 days"
                      </p>
                      <p className="text-sm text-gray-300" data-id="element-205">
                        1.2M views, 89K likes
                      </p>
                    </div>
                    <div data-id="element-206">
                      <p className="font-medium" data-id="element-207">
                        2. "Morning routine that changed my life"
                      </p>
                      <p className="text-sm text-gray-300" data-id="element-208">
                        450K views, 34K likes
                      </p>
                    </div>
                  </div>
                  <p className="text-xs mt-3 text-primary font-medium ml-7" data-id="element-209">
                    Keep creating! Text /stats for your full dashboard.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Technical Features */}
        <div className="mb-16" data-id="element-210">
          <h2 className="text-2xl font-bold mb-8" data-id="element-211">Smart Technical Features</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-212">
            <div className="bg-secondary/30 p-4 rounded-lg flex items-start gap-3" data-id="element-213">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-214">
                <LinkIcon size={16} className="text-primary" data-id="element-215" />
              </div>
              <div data-id="element-216">
                <p className="font-medium" data-id="element-217">Smart URL Parsing</p>
                <p className="text-sm text-muted-foreground" data-id="element-218">
                  Handles @handle OR full TikTok URLs
                </p>
              </div>
            </div>
            <div className="bg-secondary/30 p-4 rounded-lg flex items-start gap-3" data-id="element-219">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-220">
                <User size={16} className="text-primary" data-id="element-221" />
              </div>
              <div data-id="element-222">
                <p className="font-medium" data-id="element-223">Creator Detection</p>
                <p className="text-sm text-muted-foreground" data-id="element-224">
                  Automatically identifies your own videos
                </p>
              </div>
            </div>
            <div className="bg-secondary/30 p-4 rounded-lg flex items-start gap-3" data-id="element-225">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-226">
                <BarChart3 size={16} className="text-primary" data-id="element-227" />
              </div>
              <div data-id="element-228">
                <p className="font-medium" data-id="element-229">Rich Stats Tracking</p>
                <p className="text-sm text-muted-foreground" data-id="element-230">
                  Views, likes, top creators, referrals
                </p>
              </div>
            </div>
            <div className="bg-secondary/30 p-4 rounded-lg flex items-start gap-3" data-id="element-231">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-232">
                <Smartphone size={16} className="text-primary" data-id="element-233" />
              </div>
              <div data-id="element-234">
                <p className="font-medium" data-id="element-235">SMS Optimized</p>
                <p className="text-sm text-muted-foreground" data-id="element-236">
                  Concise, scannable format for mobile
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* CTA Section */}
        <div className="mb-16 bg-primary/5 rounded-xl p-8 border border-primary/20" data-id="element-237">
          <h2 className="text-2xl font-bold mb-4" data-id="element-238">
            Ready to Become a Creator?
          </h2>
          <p className="text-lg text-muted-foreground mb-6 max-w-xl mx-auto" data-id="element-239">
            Link your TikTok account now and unlock powerful analytics, track
            your performance, and get special creator perks.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-240">
            <a href={smsHref} data-id="element-241">
              <Button size="lg" className="w-full sm:w-auto" data-id="element-242">
                <MessageSquare size={16} className="mr-2" data-id="element-243" />
                Text Now
              </Button>
            </a>
            <div className="flex items-center gap-2 px-4 py-2 bg-secondary rounded-full cursor-pointer" onClick={handleCopyNumber} data-id="element-244">
              <span className="font-medium" data-id="element-245">{phoneNumber}</span>
              {copied ? <Check size={16} className="text-green-500" data-id="element-246" /> : <Copy size={16} data-id="element-247" />}
            </div>
          </div>
        </div>
        {/* Why This Matters */}
        <div className="mb-16" data-id="element-248">
          <h2 className="text-2xl font-bold mb-8" data-id="element-249">Why This is Game-Changing</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-250">
            <div className="bg-secondary/30 p-5 rounded-lg text-left" data-id="element-251">
              <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-252">
                <User size={18} className="text-primary mr-2" data-id="element-253" />
                For Creators
              </h3>
              <ul className="space-y-2" data-id="element-254">
                <li className="flex items-start gap-2" data-id="element-255">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-256" />
                  <span data-id="element-257">Track performance without logging into TikTok</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-258">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-259" />
                  <span data-id="element-260">Identify your most successful content</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-261">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-262" />
                  <span data-id="element-263">Get special features for your own videos</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-264">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-265" />
                  <span data-id="element-266">Easy sharing of stats with collaborators</span>
                </li>
              </ul>
            </div>
            <div className="bg-secondary/30 p-5 rounded-lg text-left" data-id="element-267">
              <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-268">
                <Share2 size={18} className="text-primary mr-2" data-id="element-269" />
                For Everyone
              </h3>
              <ul className="space-y-2" data-id="element-270">
                <li className="flex items-start gap-2" data-id="element-271">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-272" />
                  <span data-id="element-273">Feel like a TikTok pro with creator identity</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-274">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-275" />
                  <span data-id="element-276">Share stats with friends (natural viral loops)</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-277">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-278" />
                  <span data-id="element-279">Earn referral credits by sharing with friends</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-280">
                  <CheckCircle size={16} className="text-success mt-1 flex-shrink-0" data-id="element-281" />
                  <span data-id="element-282">Unique SMS analytics no other service offers</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Trust Indicators */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-muted-foreground mb-8" data-id="element-283">
          <div className="flex items-center gap-2" data-id="element-284">
            <CheckCircle size={16} className="text-success" data-id="element-285" />
            <span data-id="element-286">10,000+ Creators Tracked</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-287">
            <CheckCircle size={16} className="text-success" data-id="element-288" />
            <span data-id="element-289">100M+ Views Analyzed</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-290">
            <CheckCircle size={16} className="text-success" data-id="element-291" />
            <span data-id="element-292">Private & Secure</span>
          </div>
        </div>
        {/* Footer CTA */}
        <div className="border-t border-border/50 pt-8" data-id="element-293">
          <p className="text-lg font-medium mb-4" data-id="element-294">Ready to get started?</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-295">
            <a href={smsHref} data-id="element-296">
              <Button size="lg" data-id="element-297">
                <MessageSquare size={16} className="mr-2" data-id="element-298" />
                Text /link to {phoneNumber}
              </Button>
            </a>
            <Link to="/app" data-id="element-299">
              <Button variant="outline" size="lg" data-id="element-300">
                Go to Web App
                <ArrowRight size={16} className="ml-2" data-id="element-301" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>;
}